module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('img', {
    staticClass: "patientList-logo",
    attrs: {
      "src": require("../../assets/LOGO.png")
    },
    on: {
      "click": _vm.home
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "patientList-user"
  }, [_c('div', {
    staticClass: "recent-updates"
  }, [(_vm.isHcpDoctor) ? _c('p', [_c('a', {
    attrs: {
      "href": "/static/Recent_update_hcp.pdf",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1105_Recent_Updates')))])]) : _c('p', [_c('a', {
    attrs: {
      "href": "/static/Recent_update.pdf",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1105_Recent_Updates')))])])]), _vm._v(" "), _c('img', {
    staticClass: "portrait",
    attrs: {
      "src": _vm.portrait
    }
  }), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "id": "dropdown"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('label', [_vm._v(_vm._s(_vm.username)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageTip),
      expression: "messageTip"
    }],
    staticClass: "messageTip"
  })]), _vm._v(" "), _c('img', {
    staticClass: "patientList-drown",
    attrs: {
      "src": require("../../assets/arrow_down.png")
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "id": "dropdown-menu"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHcp),
      expression: "isHcp"
    }],
    attrs: {
      "command": "messages"
    }
  }, [_vm._v(_vm._s(_vm.$t('messages'))), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageTip),
      expression: "messageTip"
    }],
    staticClass: "messageTip"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHcp),
      expression: "!isHcp"
    }],
    attrs: {
      "command": "connect"
    }
  }, [_vm._v(_vm._s(_vm.$t('connection'))), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageTip),
      expression: "messageTip"
    }],
    staticClass: "messageTip"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "profile"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "changePassword"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1215_Security')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": "",
      "command": "loginOut"
    }
  }, [_vm._v(_vm._s(_vm.$t('sign out')))])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5753a14f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common-template/HCPHeader.vue
// module id = 1466
// module chunks = 7